var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNeutral = function SvgIconNeutral(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66663 12.0003C3.66663 7.40033 7.39996 3.66699 12 3.66699C16.6 3.66699 20.3333 7.40033 20.3333 12.0003C20.3333 16.6003 16.6 20.3337 12 20.3337C7.39996 20.3337 3.66663 16.6003 3.66663 12.0003ZM14.5583 11.3753L13.8083 12.142C13.2083 12.7503 12.8333 13.2503 12.8333 14.5003H11.1666V14.0837C11.1666 13.167 11.5416 12.3337 12.1416 11.7253L13.175 10.6753C13.4833 10.3753 13.6666 9.95866 13.6666 9.50033C13.6666 8.58366 12.9166 7.83366 12 7.83366C11.0833 7.83366 10.3333 8.58366 10.3333 9.50033H8.66663C8.66663 7.65866 10.1583 6.16699 12 6.16699C13.8416 6.16699 15.3333 7.65866 15.3333 9.50033C15.3333 10.2337 15.0333 10.9003 14.5583 11.3753ZM11.1666 17.8337V16.167H12.8333V17.8337H11.1666Z",
    fill: "black"
  })));
};
export default SvgIconNeutral;